import { Routes } from '@angular/router';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { DefaultLayoutComponent, PublicLayoutComponent } from './containers';
import { LoginFailedComponent } from './components/login-failed/login-failed.component';
import { MsalGuard } from '@azure/msal-angular';

export const routes: Routes = [
    // Layout para usuarios autenticados
    {
        path: '',
        component: DefaultLayoutComponent,
        canActivate: [MsalGuard],
        children: [
            {
                path: '',
                redirectTo: 'home',
                pathMatch: 'full',
            },
            {
                path: 'home',
                loadChildren: () =>
                import('./components/home/home.routes').then(m => m.homeRoutes)
            },
            {
                path: 'admin',
                loadChildren: () =>
                import('./components/admin/admin.routes').then(m => m.adminRoutes)
            },
            {
                path: 'statistics',
                loadChildren: () =>
                import('./components/admin/statistics/statistics.routes').then(m => m.statisticsRoutes)
            }
        ]
    },
    {
      path: 'login-failed',
      component: LoginFailedComponent,
    },
    // Layout para public
    {
        path: '',
        component: PublicLayoutComponent,
        children: [
            {
                path: 'public',
                loadChildren: () =>
                import('./components/public/public.routes').then(m => m.publicRoutes)
            }
        ]
    },
    // Fallback
    {
        path: '**',
        component: NotFoundComponent
    }
];
